export type MailboxInfo = 'Explicit' | 'Connected' | 'Archive' | 'Default';

export interface DatapointOptions {
    customData?: { [index: string]: number | string | boolean | Date };
    headersCustomData?: (headers: Headers) => { [index: string]: number | string | boolean | Date };
    jsonCustomData?: (json: any) => { [index: string]: number | string | boolean | Date };
    mailbox?: MailboxInfo;
}

export enum CustomBaseUrl {
    AnonymousCalendar = '/owa/calendar',
}

// We can not use for..of or any other iterator for headers
// as it is not supported on some older version of Edge e.g. 15.15063, 14.14393.
// We also can't use forEach to iterate over headers as it is also not supported
// in all browsers e.g. Firefox. Hence we create this type without iterators.
export type HeadersWithoutIterator = Omit<Headers, 'entries' | 'keys' | 'values' | 'forEach'>;

export type OnBeforeRetry = (r: Response, options: RequestOptions) => Promise<string | undefined>;

export interface RequestOptions {
    headers?: HeadersWithoutIterator;
    method?: string;
    returnFullResponseOnSuccess?: boolean;
    isUserActivity?: boolean;
    noEmptyPost?: boolean;
    datapoint?: DatapointOptions;
    authNeededOnUnAuthorized?: boolean;
    customBaseUrl?: CustomBaseUrl;
    customBaseUrlSubPath?: string;
    priority?: number;
    isInPrefetchMode?: boolean;
    prefetchPriority?: number;
    timeoutMS?: number;
    endpoint?: string;
    overrideIsRetriableStatus?: (status: number) => boolean;
    onBeforeRetry?: OnBeforeRetry;
}

export interface InternalRequestOptions extends RequestOptions {
    credentials?: RequestCredentials;
    body?: string;
}

export default RequestOptions;
